import { render, staticRenderFns } from "./WorkflowStep.vue?vue&type=template&id=5b40b0c3&"
import script from "./WorkflowStep.vue?vue&type=script&lang=js&"
export * from "./WorkflowStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports